<template>
  <div class="be-wrapper be-login be-signup">
    <div class="be-content">
      <div class="main-content container-fluid">
        <div class="splash-container sign-up">
          <div class="panel panel-default panel-border-color panel-border-color-primary">
            <div class="panel-body">
              <form>
                <span class="splash-title xs-pb-20"><h3>Регистрация пользователя</h3></span>
                <div class="form-group" :class="{'has-error' : errors.has('lastName')}">
                  <label class="control-label">Фамилия*</label>
                  <input v-validate="'required'" class="form-control"
                         data-vv-as="Фамилия" :class="{'input': true, 'is-danger': errors.has('lastName') }"
                         name="lastName"
                         type="text" placeholder="Фамилия" v-model="lastName" autocomplete="on">
                  <span v-show="errors.has('lastName')" class="text-danger">{{ errors.first('lastName') }}</span>
                </div>
                <div class="form-group" :class="{'has-error' : errors.has('firstName')}">
                  <label class="control-label">Имя*</label>
                  <input v-validate="'required'" class="form-control"
                         data-vv-as="Имя" :class="{'input': true, 'is-danger': errors.has('firstName') }"
                         name="firstName"
                         type="text" placeholder="Имя" v-model="firstName" autocomplete="on">
                  <span v-show="errors.has('firstName')" class="text-danger">{{ errors.first('firstName') }}</span>
                </div>
                <div class="form-group" :class="{'has-error' : errors.has('middleName')}">
                  <label class="control-label">Отчество</label>
                  <input v-validate="" class="form-control"
                         data-vv-as="Отчество" :class="{'input': true, 'is-danger': errors.has('middleName') }"
                         name="middleName"
                         type="text" placeholder="Отчество" v-model="middleName" autocomplete="on">
                  <span v-show="errors.has('middleName')" class="text-danger">{{ errors.first('middleName') }}</span>
                </div>
                <div class="form-group" :class="{'has-error' : errors.has('phone')}">
                  <label class="control-label">Контактный номер телефона*</label>
                  <input v-validate="'required|numeric'" class="form-control"
                         data-vv-as="Контактный номер телефона"
                         :class="{'input': true, 'is-danger': errors.has('phone') }" name="phone"
                         type="text" placeholder="Контактный номер телефона" v-model="phone" autocomplete="on">
                  <span v-show="errors.has('phone')" class="text-danger">{{ errors.first('phone') }}</span>
                </div>
                <div class="form-group" :class="{'has-error' : errors.has('email')}">
                  <label class="control-label">Email* (используется для входа в систему)</label>
                  <input v-validate="'required|email'" class="form-control"
                         data-vv-as="Email" :class="{'input': true, 'is-danger': errors.has('email') }" name="email"
                         type="text" placeholder="Email" v-model="email" autocomplete="on">
                  <span v-show="errors.has('email')" class="text-danger">{{ errors.first('email') }}</span>
                </div>
                <div class="form-group row"
                     :class="{'has-error' : errors.has('password1') || errors.has('password2')}">
                  <div class="col-xs-6">
                    <label class="control-label">Пароль*</label>
                    <input v-validate="'required|min:8'" class="form-control"
                           data-vv-as="Пароль" :class="{'input': true, 'is-danger': errors.has('password1') }"
                           name="password1" ref="password1"
                           type="password" placeholder="Пароль" v-model="password" autocomplete="on">
                    <span v-show="errors.has('password1')" class="text-danger">{{ errors.first('password1') }}</span>
                  </div>
                  <div class="col-xs-6">
                    <label class="control-label">Подтвердите пароль*</label>
                    <input v-validate="'required|confirmed:password1|min:8'" class="form-control"
                           data-vv-as="Подтвердите пароль"
                           :class="{'input': true, 'is-danger': errors.has('password2') }" name="password2"
                           type="password" placeholder="Подтвердите пароль" v-model="confirmPassword"
                           autocomplete="on">
                    <span v-show="errors.has('password2')" class="text-danger">{{ errors.first('password2')
                      }}</span>
                  </div>
                </div>
                <label>Поля отмеченные * обязательны для заполнения.</label>
                <div class="form-group xs-pt-10">
                  <div class="be-checkbox">
                    <input type="checkbox" v-model="agreeWithRules" id="remember">
                    <label for="remember">Я согласен с <a href="#">правилами и условиями</a> сервиса.</label>
                  </div>
                </div>
                <div class="alert alert-danger" v-if="errorMessages" v-for="message in errorMessages">
                  <p>{{ message }}</p>
                </div>
              </form>
              <div class="form-group xs-pt-10">
                <button class="btn btn-block btn-primary btn-xl"
                        :disabled="!agreeWithRules" @click="signUp()">Зарегистрироваться
                </button>
              </div>
              <!--<form>-->
                <!--<div class="title"><span class="splash-title xs-pb-15">или</span>-->
                <!--</div>-->
                <!--<div class="form-group row social-signup">-->
                  <!--<div class="col-xs-6">-->
                    <!--<button type="button" class="btn btn-lg btn-block btn-social btn-facebook btn-color"><i-->
                      <!--class="mdi mdi-vk icon icon-left"></i> ВКонтакте-->
                    <!--</button>-->
                  <!--</div>-->
                  <!--<div class="col-xs-6">-->
                    <!--<button type="button" class="btn btn-lg btn-block btn-social btn-google-plus btn-color"><i-->
                      <!--class="mdi mdi-google-plus icon icon-left"></i> Google Plus-->
                    <!--</button>-->
                  <!--</div>-->
                <!--</div>-->
                <!--<div class="form-group row social-signup">-->
                  <!--<div class="col-xs-6">-->
                    <!--<button type="button" class="btn btn-lg btn-block btn-social btn-color btn-warning"><i-->
                      <!--class="mdi mdi-odnoklassniki icon icon-left"></i> Одноклассники-->
                    <!--</button>-->
                  <!--</div>-->
                  <!--<div class="col-xs-6">-->
                    <!--<button type="button" class="btn btn-lg btn-block btn-social btn-facebook btn-color"><i-->
                      <!--class="mdi mdi-facebook icon icon-left"></i> Facebook-->
                    <!--</button>-->
                  <!--</div>-->
                <!--</div>-->
              <!--</form>-->
              <div class="splash-footer">
                <span>Уже зарегистрированы?<router-link :to="{name:'login'}">Авторизация</router-link></span>
              </div>
            </div>
          </div>
          <div class="splash-footer">&copy; 2018 ООО "Квирко"</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'

  export default {
    data () {
      return {
        firstName: null,
        lastName: null,
        middleName: null,
        email: null,
        phone: null,
        password: null,
        confirmPassword: null,
        agreeWithRules: false,
        errorMessages: null
      }
    },
    computed: {
      registrationData () {
        return {
          last_name: this.lastName,
          first_name: this.firstName,
          middle_name: this.middleName,
          email: this.email,
          password1: this.password,
          password2: this.confirmPassword,
          phone: this.phone
        }
      }
    },
    methods: {
      signUp () {
        this.errors.clear()
        this.errorMessages = null
        this.$validator.validateAll().then((result) => {
          if (result) {
            axios.post('/api/rest-auth/registration/', this.registrationData).then(
              (response) => {
                if (response.status === 201) {
                  this.$router.push({name: 'signupSuccess'})
                }
              },
              (error) => {
                if (error.response.status === 400) {
                  for (let [key, value] of Object.entries(error.response.data)) {
                    this.errors.add(key, value[0], 'server')
                  }
                  this.errors.add(error.response.data)
                } else if (error.response.status >= 400) {
                  this.errorMessages = ['Ошибка!. Попробуйте позже.']
                }
              }
            )
          } else {
            this.errorMessages = ['Проверьте введенные данные!']
          }
        })
      }
    }
  }
</script>
<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/auth/SignUp.vue